export const BASE_ICON_CLASSNAME = 'w-4 h-4 mr-2';
